import React from "react";
import { BettingEventStatus, FreeplayLeague } from "@freeplay/shared-code";
import { useEvent } from "../../contexts/EventContext";
import { BespokeGameController } from "../../controllers/BespokeGameController";
import { BespokePickOverviewController } from "../../controllers/BespokePickOverviewController";
import { GameController } from "../../controllers/GameController";
import { PickOverviewController } from "../../controllers/PickOverviewController";
import { PicksSubmittedController } from "../../controllers/PicksSubmittedController";

const BespokeGameView = () => {
    const { currentEntry, showSubmittedScreen, currentEvent } = useEvent();
    if (showSubmittedScreen) {
        return <PicksSubmittedController />;
    } else if (currentEntry || currentEvent?.eventStatus === BettingEventStatus.RESULTED) {
        return <BespokePickOverviewController />;
    }
    return <BespokeGameController />;
};

const KambiGameView = () => {
    const { currentEntry, showSubmittedScreen, currentEvent } = useEvent();
    if (showSubmittedScreen) {
        return <PicksSubmittedController />;
    } else if (currentEntry || currentEvent?.eventStatus === BettingEventStatus.RESULTED) {
        return <PickOverviewController />;
    }
    return <GameController />;
};

export const EventView = (): JSX.Element => {
    const { currentEvent } = useEvent();
    if (currentEvent?.game.league === FreeplayLeague.Other) {
        return <BespokeGameView />;
    } else {
        return <KambiGameView />;
    }
};
